// extracted by mini-css-extract-plugin
export default {"wrapper":"ChangePassword_wrapper__Dme9V","input_wrapper":"ChangePassword_input_wrapper__Nw1vr","error_msg":"ChangePassword_error_msg__HhbFp"};